import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { KPI } from '../../../@core/api';
import { NbDialogRef, NbCardModule, NbButtonModule, NbSelectModule, NbOptionModule, NbLayoutModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { I18nService, PostponementsService } from '../../../@core/utils';
import { CurrencyPipe } from '../../pipes';

@Component({
    selector: 'app-investment-change-confirm-dialog',
    templateUrl: './investment-change-confirm-dialog.component.html',
    styleUrls: ['./investment-change-confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    FormsModule,
    NbCardModule,
    NbButtonModule,
    TranslateModule,
    NbSelectModule,
    NbOptionModule,
    CurrencyPipe,
    NbLayoutModule
],
})
export class InvestmentChangeConfirmDialogComponent implements OnInit, OnDestroy {

  public investmentsIds: number[];
  private subscriptions: Subscription[] = [];
  public reasons: KPI.PostponementReason[] = [];
  public reasonId: number;
  public fromYear: number;
  public toYear: number;
  public fromStatus: string;
  public toStatus: string;
  public addingTag: boolean;
  public removingTag: boolean;
  public tag: string;
  public closingPrecision :string;
  public scenario: KPI.InvestmentScenario;
  public linkedInvestmentsData = [];
  public currency = '€';

  constructor(
    private dialogRef: NbDialogRef<InvestmentChangeConfirmDialogComponent>,
    private postponementsService: PostponementsService,
    private i18n: I18nService
  ) { }

  public ngOnInit(): void {
    this.currency = this.i18n.getCurrency();
    this.subscriptions.push(
      this.postponementsService.postponementReasons$.subscribe((reasons) => {
        this.reasons = reasons
      })
    );
  }

  public close(): void {
    if (this.fromYear && this.toYear) {
      this.dialogRef.close({
        confirmed: false,
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  public submit(): void {
    if (this.fromYear && this.toYear) {
      this.dialogRef.close({
        confirmed: true,
        reasonId: this.reasonId,
      });
    } else {
      this.dialogRef.close(true)
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public getLinkedInvestmentYear(data): number {
    return data[`year_scenario_${this.scenario.id}`];
  }

}
